export default "__VITE_ASSET__BrkVN7Ir__"